export default theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderTop: '1px solid #e6e6e6',
    paddingTop: theme.spacing.unit,
    margin: theme.spacing.unit,
    marginBottom: 0,
    fontWeight: 'bold',
  },
  thumbnail: {
    maxWidth: 80,
    display: 'block',
    padding: 1
  },
  link: {
    display: 'block'
  }
});

